import React, { useCallback, useState } from 'react';

import PopperCard from '../../../../../design_system/popper_card/popper_card';
import List from '../../../../../design_system/list/list';
import ListItem from '../../../../../design_system/list_item/list_item';

import classes from './language_selector_dropdown.module.css';

const availableLanguages = ['fr', 'en'];

const getLabelFromValue = (value) => {
	if (value === 'en') {
		return 'English'
	}
	return 'Français'
}

const LanguageSelectorDropdown = ({ ...other }) => {
	const [activeFilters, setActiveFilters] = useState([]);
	const [, setUpdateState] = useState();
	const handleSelection = useCallback((label) => {
		const newFilters = activeFilters;
		if (activeFilters.includes(label)) {
			newFilters.splice(activeFilters.indexOf(label), 1);
		} else {
			newFilters.push(label);
		}
		setActiveFilters(newFilters);
		setUpdateState({});
	}, [activeFilters]);
	return (
		<PopperCard
			className={classes.container}
			{...other}
		>
			<List>
				{availableLanguages.map((value) => {
					return (
						<ListItem
							className={classes.listItem}
							button
							onClick={() => handleSelection(value)}
						>
							<span>
								{getLabelFromValue(value)}
							</span>
						</ListItem>
					);
				})}
			</List>
		</PopperCard>
	);
}

export default LanguageSelectorDropdown;
